import request from '@/utils/request'

const PURCHASE_API = process.env.VUE_APP_PURCHASE_API
// const PURCHASE_API = 'http://127.0.0.1:4523/m1/2483590-0-default'

// 开启线上评审
export function startInquiryReviewApi(reviewId, params, data) {
  return request({
    url:
      PURCHASE_API + `/workbench/purchaser/inquiry-reviews/${reviewId}/start`,
    method: 'post',
    params,
    data
  })
}

// 查询询比采购单信息
export function getInquiryReviewOrderApi(reviewId, orderId) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/review-orders/${orderId}/info`,
    method: 'get'
  })
}

// 查询评审供应商列表
export function getPurchaseReviewSupplierListApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/review-suppliers/list`,
    method: 'get',
    params
  })
}

// 分页查询打分表
export function getInquiryReviewScorePageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/review-scores/page`,
    method: 'get',
    params
  })
}

// 查询综合排序表信息
export function getInquiryReviewRankPageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/review-ranks/page`,
    method: 'get',
    params
  })
}

// 获取供应商的报价文件预览地址
export function getInquiryReviewQuoteFileApi({
  reviewId,
  orderId,
  supplierId,
  fileType
}) {
  const params = { orderId, supplierId, fileType }
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/review-scores/offer-file`,
    method: 'get',
    params
  })
}

// 查询报价供应商列表
export function getInquiryReviewQuoteRoundSupplierListApi(reviewId, params) {
  return request(
    {
      url:
        PURCHASE_API +
        `/workbench/purchaser/inquiry-reviews/${reviewId}/offer-suppliers/page`,
      method: 'get',
      params
    },
    false
  )
}

// 查询本轮报价数量统计
export function getInquiryReviewQuoteRoundTotalApi(reviewId, params) {
  return request(
    {
      url:
        PURCHASE_API +
        `/workbench/purchaser/inquiry-reviews/${reviewId}/offer-suppliers/total`,
      method: 'get',
      params
    },
    false
  )
}

// 提前结束当轮报价
export function endInquiryReviewQuoteRoundApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/offer-end`,
    method: 'post',
    params
  })
}

/**
 * 查询供应商的报价列表
 */
export function getInquiryReviewSupplierQuoteRoundListApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/supplier-offers/list`,
    method: 'get',
    params
  })
}

/**
 * 查询某个供应商的报价详情
 */
export function getInquiryReviewSupplierQuoteDetailApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/supplier-offers/offer-detail`,
    method: 'get',
    params
  })
}

/**
 * 分页查询所有供应商的轮次报价列表
 */
export function getInquiryReviewQuoteRoundPageApi(reviewId, params) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/purchaser/inquiry-reviews/${reviewId}/round-offers/page`,
    method: 'get',
    params
  })
}
